export default __webpack_public_path__ + "static/media/tech-0-fig3.ebc550db.png";